import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Col, Container, Button, Modal, Card, Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'
import { formatoMonto } from '../../../../common/Formatos'
import { Auth, LoadingComponent } from 'recupero-comunes';
import { serviceGetHistorialProvisionesMoneda } from '../../../../api/api-visar-provision';

const GrillaPrevImplicadosHistorial = ({ action, showModalVisar, implicado}) => {
    const [data, setData] = useState([]);
    const visar_provision = useSelector((state) => state.visarProvisionReducer);
    const { cfg_form44, listaHistorialProvisionesImplicado, comboMonedas } = visar_provision;
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    const { codMonedaLocal } = Auth.currentUser();
    const [stateMoneda, setStateMoneda] = useState("");
    const [loading, setLoading] = useState(false);
    const [montoTotal, setMontoTotal] = useState("");

    useEffect(() => {
        const lista = listaHistorialProvisionesImplicado?.listaHistorialProvisionesImplicado;
        if (!lista || lista.length === 0) return;

        const grupoTotales = new Map();
        const gruposOrden = []; // para mantener el orden de aparición

        lista.forEach(item => {
          const secuencia = item.secuenciaInf || 0;
          if (!grupoTotales.has(secuencia)) {
            grupoTotales.set(secuencia, 0);
            gruposOrden.push(secuencia);
          }
          grupoTotales.set(secuencia, grupoTotales.get(secuencia) + (item.monto || 0));
        });

        const listaFinal = [];
        const seenSecuencia = new Set();

        lista.forEach((item, index) => {
          listaFinal.push({ ...item, id: `item-${index}` });
          const secuencia = item.secuenciaInf || 0;

          const siguiente = lista[index + 1];
          const secSiguiente = siguiente ? siguiente.secuenciaInf || 0 : null;
          if (!seenSecuencia.has(secuencia) && secuencia !== secSiguiente) {
            listaFinal.push({
              id: `total-${secuencia}`,
              cobertura: 'TOTAL IMPLICADO',
              monto: grupoTotales.get(secuencia),
              secuenciaInf: secuencia,
              isTotalGrupo: true,
              isSeparator: true
            });
            seenSecuencia.add(secuencia);
          }
        });
        setData(listaFinal);
      }, [listaHistorialProvisionesImplicado]);

    useEffect(() => {
      if (showModalVisar && stateMoneda) { setLoading(true); loadHistorialPretProvi(codMonedaLocal) }
    }, [stateMoneda])

    useEffect(() => {
      if (comboMonedas) setStateMoneda(codMonedaLocal);
    }, [comboMonedas])

    const loadHistorialPretProvi = async (moneda) => {
      
      setStateMoneda(moneda)
      setLoading(true)
      let query = Buffer.from(JSON.stringify({ idCaso: llaves && llaves['idCaso'], idImplicado: implicado, tipoMovimiento: action === "provision" ? 261002 : 261003, codMoneda: moneda })).toString('base64')
      const response = await serviceGetHistorialProvisionesMoneda(query);
      setData(response);
      setLoading(false)
    } 

  const [tituloModal, setTituloModal] = useState('');
  const [comentario, setComentario] = useState('Sin comentarios.');
  const [comentarioVisado, setComentarioVisado] = useState('Sin comentarios.');
  const [showModal, setShowModal] = useState(false);

  const obtenerColumnas = () => {
    return [
      {
        dataField: 'cobertura',
        text: (cfg_form44 && cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-cobertura']) ? cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-cobertura'] : 'Cobertura',
        sort: true,
        headerAlign: 'center',
        align: 'left',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'left'
        }
      },
      {
        dataField: 'monto',
        text: (cfg_form44 && cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-cobertura']) ? cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-monto'] : 'Monto',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell, row) => <span>{formatoMonto(row.monto, false)}</span>,
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'estado',
        text: (cfg_form44 && cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-cobertura']) ? cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-estado'] : 'Estado',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'left'
        }
      },
      {
        dataField: 'fechaRegistro',
        text: (cfg_form44 && cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-fechaultreg']) ? cfg_form44.cfg_form44['modalprovisiones-grilla-histimpl-fechaultreg'] : 'Fecha Ult.Reg',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div className="table_header_font">
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' },
        formatter:(cell, row)=>{
          if(cell) {
            return <>        
                <a href='#' style={{textDecoration:''}} onClick={(e)=>{
                  e.preventDefault()
                  setComentario(row?.comentario ? row.comentario : '<Sin Observaciones>');
                  setComentarioVisado(row?.comentarioVisado ? row?.comentarioVisado : '<Sin Observaciones>');
                  setTituloModal(action == 'button' ? 'Provisiones' : 'Propuesta Indemnización');// + " " + row?.nombreImplicado)
                  setShowModal(true);
                  }}
                >{cell}</a>                  
            </>
           }else{
               return cell
           }
         }
      }
    ]
  }

  return (
    <>
      <LoadingComponent show={loading} />
      <Container>
        <Row className='mt-2 mb-3'>
          <Col>
            <ToolkitProvider
              bootstrap4
              keyField='id'
              data={data ? data : []}
              columns={obtenerColumnas()}
              defaultSorted={[{ dataField: 'secuencia', order: 'asc' }]}
            >
              {(props) => (
                <div style={{ maxHeight: '450px', overflowY: 'auto', display: 'block' }}>
                  <BootstrapTable
                    {...props.baseProps}
                    bordered={false}
                    headerWrapperClasses='table-secondary'
                    rowClasses={(row) => {
                      let classes = '';
                      if (row.isTotalGrupo) classes += ' fw-bold bg-light';
                      if (row.isSeparator) classes += ' row-separator';
                      return classes.trim();
                    }}
                    noDataIndication={
                      <div className='text-center'>
                        No hay registros encontrados
                      </div>
                    }
                  />
                </div>
              )}
            </ToolkitProvider>
          </Col>
        </Row>        
      </Container>
      <Modal show={showModal} onHide={() => setShowModal(false)} size='md'>
          <Card>
              <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#e8761a', color: 'white' }}>
                  Observaciones - {tituloModal}
              </Card.Header>
              <Card.Body>
                  <h5 className="card-title">Responsable Gestión:</h5>
                  {comentario}
                  <br/><br/>
                  <h5 className="card-title">Analista Compañía:</h5>
                  {comentarioVisado}
              </Card.Body>
              <Card.Footer style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button className='m-2 w-auto' variant='outline-info' onClick={() => setShowModal(false)}>Cerrar</Button>
              </Card.Footer>
          </Card>
      </Modal>
      <style type='text/css'>
        {`
          .table_header_font {
            font-size: 15px;
          },
          .fw-bold {
            font-weight: bold !important;
          }
          .row-separator td {
            border-bottom: 3px solid #6c757d !important;
          }
        `}
      </style>
    </>
  )
}

export default GrillaPrevImplicadosHistorial